export default __webpack_public_path__ + "static/2-5_HSR_Icon-4cb1353fae109f24203bfacafa848da8.png";